import $ from 'jquery';
import Application from '@ember/application';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import config from 'garaje/config/environment';
import 'moment-timezone'; // to use moment with timezone
import Ember from 'ember';

export default class App extends Application {
  modulePrefix = config.modulePrefix;
  podModulePrefix = config.podModulePrefix;
  Resolver = Resolver;

  ready() {
    if (config.isCypress && !window.Ember) {
      // we need this, because cypress tests are expecting Ember global in window
      window.Ember = Ember;
    }

    window.global = window; // for rome package

    // cancels the loading timer when app is completely ready to go - initializer doesn't work b/c we have deferReadiness for google maps
    window.clearTimeout(window.loadingTimer);
    const loadingMessage = $('.load-error');
    if (loadingMessage.first()) {
      loadingMessage.first().removeClass('display');
    }
  }

  constructor() {
    super(...arguments);

    this.engines = {
      'employee-schedule': {
        dependencies: {
          services: [
            'authz',
            'metrics',
            'state',
            'store',
            'flashMessages',
            'linkManager',
            'currentAdmin',
            'featureConfig',
            'localStorage',
            'workplaceMetrics',
            'abilities',
            'impressions',
          ],
          externalRoutes: {
            desks: 'desks',
            createEmployeeScreeningFlow: 'workplace.settings.employees.registration',
            profile: 'profile.document',
            liveMap: 'spaces.maps.live.show',
          },
        },
      },
      roomba: {
        dependencies: {
          services: [
            'metrics',
            'state',
            'store',
            'subscriptions',
            'flashMessages',
            'linkManager',
            'currentAdmin',
            'featureFlags',
            'featureConfig',
            'localStorage',
          ],
          externalRoutes: {
            integrations: 'integrations',
          },
        },
      },
    };
  }
}

loadInitializers(App, config.modulePrefix);
